export enum TicketConfigurationType {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
  SET_CAPACITY = 'SET_CAPACITY',
  OVERVIEW = 'OVERVIEW',
}
